var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.28 212.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #363649;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #eaeaea;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Image_28",
    "data-name": "Image 28",
    className: "cls-3",
    width: 216.28,
    height: 211.82,
    rx: 20,
    ry: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m154.33,158.31c0-46.39-37.61-84-84-84-29.22,0-54.95,14.93-70,37.57v82.43c0,9.94,8.06,18,18,18h116.33c12.27-14.6,19.67-33.43,19.67-54Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19791",
    "data-name": "Group 19791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19772",
    "data-name": "Group 19772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1814119_launch_open_share_icon",
    "data-name": " 1814119 launch open share icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-External-Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-118",
    className: "cls-1",
    d: "m70.87,161.46l-3.27-3.27,36.72-36.57,3.13,3.13-36.57,36.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-119",
    className: "cls-1",
    d: "m108.3,145.09h-4.83v-19.5h-19.5v-4.83h24.33v24.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-120",
    className: "cls-1",
    d: "m96.06,189.06h-48.81c-4-.02-7.24-3.26-7.26-7.26v-48.81c.02-4,3.26-7.24,7.26-7.26h26.9v4.84h-26.9c-1.32.04-2.38,1.1-2.42,2.42v48.81c.04,1.32,1.1,2.38,2.42,2.42h48.81c1.32-.04,2.38-1.1,2.42-2.42v-26.9h4.84v26.9c.08,3.93-3.03,7.18-6.96,7.26-.1,0-.2,0-.3,0"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapIcon);
export default __webpack_public_path__ + "static/media/roadmapIcon.2865371cc697afb66274e150a9442eeb.svg";
export { ForwardRef as ReactComponent };